import ClicksWithFtdFilter from "./ClicksWithFtdFilter";
import ClicksWithFtdItem from "./ClicksWithFtdItem";

const ClicksWithFtd = () => {
  return (
    <>
      <ClicksWithFtdFilter />
      <ClicksWithFtdItem/>
    </>
  );
};

export default ClicksWithFtd;
